import React from 'react';
import moment from 'moment';

import { enum as dashboardVisitActions } from '../../../../../../../../enums/dashboard-visit-actions';

function getActionHint(action) {
	switch (action) {
		case dashboardVisitActions.signup:
			return 'affiliate is registered';
		case dashboardVisitActions.login:
			return 'affiliate is logged in';
		case dashboardVisitActions.signin:
			return 'affiliate is authorized';
	}
}

function LongLink({ child }) {
	return (
		<input
			className="dashboard-visits-long-link"
			readOnly={true}
			value={child}
		/>
	);
}

export default [
	[
		{
			index: 'date',
			header: {
				title: 'date'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'action',
			header: {
				title: 'action'
			},
			column: {
				hint: getActionHint
			}
		},
		{
			index: 'referer',
			header: {
				title: 'referer'
			},
			column: {
				render: LongLink
			}
		},
		{
			index: 'link',
			header: {
				title: 'link'
			},
			column: {
				render: LongLink
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/dashboard-visits/table-initial-data.js